<template>
  <div>
    <div class="user-content">
      <van-icon name="user-circle-o" size="60" color="#fff"/>
      <div class="user-info">
        <p>{{ userName }}</p>
      </div>
    </div>
    <div>
      <van-cell :title="$t('module.listSty')" is-link />
      <van-cell :title="$t('module.upPwd')" is-link />
      <van-cell :title="$t('module.printConfig')" is-link />
      <div style="padding:10px">
        <van-button type="info" block @click="handleLogOut">{{ $t('common.exit') }}</van-button>
      </div>
    </div>
   

    <van-tabbar v-model="activeMenu">
      <van-tabbar-item replace to="/index" icon="home-o">{{ $t('module.index') }}</van-tabbar-item>
      <van-tabbar-item icon="orders-o">{{ $t('module.excel') }}</van-tabbar-item>
      <van-tabbar-item replace to="/about" icon="contact">{{ $t('module.about') }}</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name:"about",
  data(){
    return {
      userName:"",
      activeMenu:2
    }
  },
  computed:{
    ...mapGetters(['menuType'])
  },
  methods:{
    handleLogOut(){
      // sessionStorage.clear();
      // this.$router.push({ name: "login" });
      // location.reload()
      this.http.get(`/rf/loginOut/${this.userName}`).then(res => {
        if (res.status == "200" && res.data.returnCode == "200") {
          sessionStorage.clear();
          this.$router.push({ name: "login" });
          location.reload()
        }
      })
    },
    content(route){
      this.$router.push({name:route.value})
    },
    getMenuList(){
      this.http.get(`/rf/switchWmwhse/${this.activeWms.value}`).then(res => {
        if (res.status == "200" && res.data.returnCode == "200") {
          this.currentList = res.data.list;
        }
      })
    }
  },
  created(){
    this.userName = JSON.parse(sessionStorage.getItem('user'))
  }
}
</script>

<style lang="less" scoped>
.user-content{
  color: #fff;
  padding: 40px;
  background: #4598d8;
  display: flex;
  align-items: center;
  .user-info{
    margin-left: 1em;
  }
}
</style>